module.exports = __webpack_public_path__ + "static/img/10_huoijian.fdd09db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/10_huoijian.png
// module id = xPLl
// module chunks = 0